import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import moment from "moment";
import { Line } from "@vds/lines";
import { ListGroup, ListGroupItem, ListGroupItemTitle, ListGroupItemSubtitle } from "@vds/lists";
import { handleModalState } from "common-components/Modal/actions/handleModalState";
import { media } from "utils/style";
import { checkAMLob } from "utils/checkAMLob";
import { customRole } from "utils/customRole";

import PendingRequest from "./SuccessModals/PendingRequest";
import PendingDelete from "./SuccessModals/PendingDelete";
import DownloadLimitModal from "./SuccessModals/DownloadLimitModal";
import PendingRequestAppeal from "./SuccessModals/PendingRequestAppeal";

import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import { ButtonWithArrowNew } from "common-components/Buttons";

class DownloadAndDelete extends Component {
  // state = {
  //   role: ""
  // };

  // componentDidMount() {
  //   let role = window.reactGlobals.customRole;

  //   if (window.reactGlobals.isMdnDisconnected || this.props.suspendedReason) {
  //     if (window.reactGlobals.amRole === "prepay") {
  //       role = "prepay_disconnected";
  //     } else {
  //       role = "disconnected";
  //     }
  //   }

  //   this.setState({ role });
  // }

  renderModal = () => {

    if (this.props.showModal) {
      if (this.props.shouldBannerRender) {
        if (this.props.showPendingModal) {
          const amLob = window.reactGlobals.amLob.toLowerCase();

          if (amLob !== "ott") {
            return (
              <PendingDelete
                dateOfRequest={this.props.dateOfRequest}
                modalContent={amLob === "vzt" ? this.props.modalContent[5] : this.props.modalContent[7]}
              />
            );
          }
        }
        if ("APPEAL" === this.props.requestType) {
          return (
            <PendingRequestAppeal
              dateOfRequest={this.props.dateOfRequest}
              appealPendingContent={this.props.modalContent[0]}
              closeModal={() => this.props.handleModalState(false)}
            />
          )
        }
       
        return (
          <PendingRequest
            downloadAvailabilityDeadline={this.props.downloadAvailabilityDeadline}
            dateOfRequest={this.props.dateOfRequest}
            downloadPending={this.props.requestType && this.props.status !== "COMPLETED"}
            downloadPendingContent={this.props.modalContent[0]}
            downloadReadyContent={this.props.modalContent[1]}
            closeModal={() => this.props.handleModalState(false)}
          />
        );
      } else if (this.props.maximumDownloadsReached) {
        const { nextRollOffDateAffidavitDownload, nextRollOffDateRegularDownload } = this.props;

        const earliestDownloadDate = moment(nextRollOffDateAffidavitDownload).isBefore(
          nextRollOffDateRegularDownload
        )
          ? nextRollOffDateAffidavitDownload
          : nextRollOffDateRegularDownload;

        return (
          <DownloadLimitModal
            handleModalState={() => this.props.handleModalState(false)}
            modalContent={this.props.modalContent[2]}
            earliestDownloadDate={moment(earliestDownloadDate).format("MMM DD, YYYY")}
          />
        );
      }
    }
  };

  isEligibleToSkipModal = (item) => {
    if (item.link === "/privacy/secure/your-correctible") {
      return true;
    }

    if (item.link === "/privacy/secure/download-information" || item.link === "/privacy/secure/delete") {
      if (this.props.showPendingModal) {
        //allow to raise the request, even though the other type of request is pending/in-progress
        //as per the 23.03.100 ER.
        return true;
      }
    }
    return false;
  }

  checkIfModalShouldRender = item => {
    if (this.isEligibleToSkipModal(item)) {
      return this.props.history.push(item.link);
    }

    if (
      (this.props.shouldBannerRender && this.props.requestType === "DOWNLOAD" && this.props.status !== "COMPLETED") ||
      this.props.showPendingModal ||
      (this.props.maximumDownloadsReached && item.link === "/privacy/secure/download-information")
    ) {
      return this.props.handleModalState();
    } else if (this.props.shouldBannerRender && this.props.requestType === "APPEAL" && this.props.status === "PENDING") {
      return this.props.handleModalState();
    } else {
      return this.props.history.push(item.link);
    }
  };

  renderLinks = () => {
    const { links } = this.props.downloadAndDeleteData;
    const { suspendedReason } = this.props;
    const role = customRole(suspendedReason);
    // const { role } = this.state;


    if (checkAMLob() === "ott" || checkAMLob() === "nico" || checkAMLob() === "vils") {
      return (
        <div>
          <ListGroup
            topLine={false}
            bottomLine={false}
            surface="light"
            viewport=""
          >
            <ListGroupItem  onClick={() => this.checkIfModalShouldRender(links[0])} actionElement="icon" ariaLabel={links[0].text}>  
              <ListGroupItemTitle  bold={false}>
                {links[0].text}
              </ListGroupItemTitle>
              <ListGroupItemSubtitle>
                {links[0].desc}
              </ListGroupItemSubtitle>
            </ListGroupItem>
            <ListGroupItem  actionElement="none">  
              <ListGroupItemTitle  bold={true}>
                {links[1].text}
              </ListGroupItemTitle>
              <ListGroupItemSubtitle>
                {links[1].desc}
              </ListGroupItemSubtitle>
            </ListGroupItem>
          </ListGroup>
        </div>
      );
    }
    if (suspendedReason === "EMAIL_NOT_VERIFIED" || suspendedReason === "EMAIL_NOT_EXIST") {
      return links.map(
        item =>
          item.role[role] === "true" && (
            <Div>
              <Bold>{item.text}</Bold>
              <P>{convertStringToElements(item.desc)}</P>
            </Div>
          )
      );
    }
    return links.map((item, i) => {
      return (
        (checkAMLob() !== "vzw" || item.role[role] === "true") && (
          <ListGroup
            key={i}
            topLine={false}
            bottomLine={links && i !== links.length - 1 ? true : false}
            surface="light"
            viewport=""
          >
            { role === "prepay_disconnected" && item.link === "/privacy/secure/download-information" ? (
              <ListGroupItem actionElement="none"> 
              <ListGroupItemTitle>{item.text}</ListGroupItemTitle>
              <ListGroupItemSubtitle>{convertStringToElements(item.desc)}</ListGroupItemSubtitle>
              </ListGroupItem>
            ) :
            (
            <ListGroupItem  onClick={() => this.checkIfModalShouldRender(item)} actionElement="icon" ariaLabel={item.text}>  
              <ListGroupItemTitle  bold={false}>
                {item.text}
              </ListGroupItemTitle>
              <ListGroupItemSubtitle>
                {convertStringToElements(item.desc)}
              </ListGroupItemSubtitle>
            </ListGroupItem>
            )}
          </ListGroup>
        )
      );
    });
  };

  render() {
    const { genericList, section_title, section_description } = this.props.downloadAndDeleteData;

    return (
      <Container>
        {this.renderModal()}
        <H2>{section_title}</H2>
        <SomeInfo>{section_description}</SomeInfo>
        <div style={{ marginBottom: "38px", maxWidth: "369px" }}>
          {/* {role === "disconnected" && checkNestedObject(genericList, [0], "list", [2], "jsonValue") && (
            <p style={{ marginBottom: "24px" }}>{convertStringToElements(genericList[0].list[2].jsonValue)}</p>
          )} */}

          {genericList &&
            (this.props.hasMadeRequest ? (
              <p>{convertStringToElements(genericList[0].list[1].jsonValue)}</p>
            ) : (
              <p>{convertStringToElements(genericList[0].list[0].jsonValue)}</p>
            ))}
        </div>
        {this.props.loading ? <RectangleLoader style={{ padding: "0" }} /> : this.renderLinks()}
      </Container>
    );
  }
}

const mapStateToProps = ({ downloadAndDelete, modalState }) => ({
  dateOfRequest: downloadAndDelete.dateOfRequest,
  requestType: downloadAndDelete.requestType,
  status: downloadAndDelete.status,
  showModal: modalState.showModal,
  downloadAvailabilityDeadline: downloadAndDelete.downloadAvailabilityDeadline,
  hasMadeRequest: downloadAndDelete.hasMadeRequest,
  noOfRegularDownloadRemaining: downloadAndDelete.noOfRegularDownloadRemaining,
  noOfAffidavitDownloadRemaining: downloadAndDelete.noOfAffidavitDownloadRemaining,
  maximumDownloadsReached: downloadAndDelete.maximumDownloadsReached,
  shouldBannerRender: downloadAndDelete.shouldBannerRender,
  nextRollOffDateRegularDownload: downloadAndDelete.nextRollOffDateRegularDownload,
  nextRollOffDateAffidavitDownload: downloadAndDelete.nextRollOffDateAffidavitDownload,
  loading: downloadAndDelete.loading,
  showPendingModal: downloadAndDelete.showPendingModal,
  suspendedReason: downloadAndDelete.suspendedReason
});

DownloadAndDelete.propTypes = {
  dateOfRequest: PropTypes.string,
  requestType: PropTypes.string,
  status: PropTypes.string,
  showModal: PropTypes.bool.isRequired,
  downloadAvailabilityDeadline: PropTypes.string,
  noOfRegularDownloadRemaining: PropTypes.number,
  noOfAffidavitDownloadRemaining: PropTypes.number,
  nextRollOffDateRegularDownload: PropTypes.string,
  nextRollOffDateAffidavitDownload: PropTypes.string,
  maximumDownloadsReached: PropTypes.bool,
  hasMadeRequest: PropTypes.bool,
  showPendingModal: PropTypes.bool,
  loading: PropTypes.bool,
  suspendedReason: PropTypes.string
};

export default compose(
  connect(
    mapStateToProps,
    { handleModalState }
  ),
  withRouter
)(DownloadAndDelete);

const Container = styled.div`
  margin-top: 64px;
  ${media.mobile`
    margin-top: 48px;
  `};
`;

const H2 = styled.h2`
  margin-bottom: 10px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px
  ${media.mobile`
    font-size: 24px;
    line-height: 24px;
  `}
`;

const P = styled.p`
  margin-top: 5px;
 max-width: 526px;
 font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
 font-size: 16px;
 font-style: normal;
 font-weight: 400;
 line-height: 20px; /* 125% */
 letter-spacing: 0.5px;
  color:#6F7171;
  max-width: ${props => (props.deleteInfo ? "596px" : "500px")};

  ${media.mobile`
  font-family: Verizon NHG eTX, Helvetica, Arial, sans-serif;;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  max-width: 296px;
  `};
`;

const SomeInfo = styled.p`
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  letter-spacing: 0.5px;
  max-width: 540px;
  margin-bottom:5px
  
`;


const Div = styled.div`
  margin-bottom: 28.2px;
  max-width: 596px;
`;

const Bold = styled.p`
  font-size: 18px;
  line-height: 19px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
`;


